export default __webpack_public_path__ + "static/media/093-up-arrow.79d4b0bc.png";